import {l} from "types/typescriptdefinisjoner_lederplan";
import {IAttributes, IAugmentedJQuery, IController, IDirective, IModule, INgModelController, IScope} from "angular";
import _ from "lodash";
import {validerPassord_asynsjekkPågår_nøkkel} from "./validerPassord";

const css = require('./validerPassordResultat.scss');

/**
 * Viser passordvalideringsresultat, i sammspill med validerPassord.ts
 */
export class ValiderPassordResultatKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('validerPassordResultat', {
                bindings: {passordFeltKontroller: '<'},
                controller: ValiderPassordResultatKontroller.forInjisering(),
                template: require('./validerPassordResultat.html')
            });
    }

    static forInjisering() {
        return [
            ValiderPassordResultatKontroller
        ]
    }

    constructor() {
    }

    passordFeltKontroller: INgModelController; //satt via bindings

    inneholderFeil(){
        if (this.passordFeltKontroller.$valid) return false;
        return ! (this.asynkSjekkKjoerer() && this.feilnøkler().length == 1);
    }

    asynkSjekkKjoerer(){
        if (this.passordFeltKontroller.$valid) return false;
        return this.feilnøkler().some(nøkkel => nøkkel == validerPassord_asynsjekkPågår_nøkkel);
    }

    private feilnøkler() {
        return _.entries(this.passordFeltKontroller.$error)
            .filter(tuppel => tuppel[1])
            .map(tuppel => tuppel[0]);
    }
}
